import React from "react";
import banner_img from "../../../images/protfolio_banner.png";
import "./Banner.css";
// import Typical from 'react-typical'

const Banner = () => {
    return (
        <div className="bg-container">
            <div className="color-container">
                <div className="container py-5">
                    <div className="row align-items-center justify-content-start">
                        <div className="col-sm-12 col-md-6 text-md-start my-5 py-5">
                            <h1 className="text-warning">
                                Hi! I am Naimur Rahman.
                            </h1>
                            <h4 className="text-success">
                                MERN stack web developer..
                            </h4>
                            <p className="text-light">
                                I am a Junior Full-stack web developer with
                                knowledge in Web design and MERN stack web
                                technologies.
                            </p>
                            <a
                                className="btn btn-secondary rounded-pill"
                                href="https://drive.google.com/file/d/1dBple9fxHmNQp6nzJezUEdOFaVevNnfH/view"
                                target="_blank"
                                rel="noreferrer"
                                download
                            >
                                View Resume
                            </a>
                        </div>
                        <div className="col-sm-12 col-md-6 image-bg p-5 rounded-circle">
                            <img
                                className="img-fluid pt-0 border rounded-pill"
                                src={banner_img}
                                alt="Dummy_Dev"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Banner;
